import { createGlobalStyle } from "styled-components";

// Import RainbowKit styles early to prevent font flashing
import '@rainbow-me/rainbowkit/styles.css';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Fredoka';
    src: url('/fonts/fredoka.ttf');
    font-display: swap;
  }

  :root {
      --bg: #F4F5F6;
      --main: #3c3c3c;
      --sub: #999;
      --border: #e5e5e5;
      --primary: #E7A2BF;
      --primary-light: #f8e3eb;
      --primary-dark: #cf7da0;
      --glacier: #73D7E8;
      --error: red;
  }

  * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-size: 10px;
      color: var(--main);
      font-family: 'Fredoka', cursive;
      line-height: 1;
  }

  /* Prevent font flashing during wallet connection */
  [data-rk] {
      font-family: 'Fredoka', cursive !important;
  }
  
  /* Ensure consistent font loading and prevent flashing */
  body {
      font-display: swap;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      opacity: 1;
      transition: opacity 0.1s ease-in;
  }

  /* Prevent text flashing during initial load */
  .font-loading {
      visibility: hidden;
  }

  .font-loaded {
      visibility: visible;
  }

  /* Prevent layout shifts and flashing */
  * {
      contain: layout style;
  }

  /* Reduce flash of unstyled content */
  body {
      visibility: visible;
      opacity: 1;
  }

  /* Smooth transitions for dynamic content */
  [data-testid], .dynamic-content {
      transition: opacity 0.15s ease-in-out;
  }

  button {
      background: none;
      border: none;
      outline: none;
  }
  
  input {
      border: none;
      outline: none;
  }

  a {
      text-decoration: none;
  }
`;

const GlobalStyles = (): JSX.Element => {
  return <GlobalStyle />;
};

export default GlobalStyles;
